import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import { reExportedColors, ITooltip } from '../../../index'

const MoreVertButton = ({ onClick, className }) => (
  <div className={className}>
    <ITooltip disableFocusListener disableTouchListener placement='top' content='More'>
      <IconButton
        onClick={onClick}
        sx={{
          alignItems: 'center',
          cursor: 'pointer',
          display: 'flex',
          fontFamily: 'Roboto',
          '&:hover': {
            background: reExportedColors.WHITE,
            borderRadius: 1
          }
        }}
      >
        <MoreVertIcon sx={{ color: reExportedColors.DARK_GREY }} />
      </IconButton>
    </ITooltip>
  </div>
)

export default MoreVertButton
